var React = require('react');

function VuePlain (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M274.768 25H215.625L172.5 94.0667L135.536 25H0L172.5 321L345 25H274.768ZM43.125 49.6667H85.0179L172.5 202.6L259.982 49.6667H301.875L172.5 271.667L43.125 49.6667Z","fill":"#25D787"}));
}

VuePlain.defaultProps = {"viewBox":"0 0 345 345","fill":"none"};

module.exports = VuePlain;

VuePlain.default = VuePlain;
